/**
 * The deck's coral card with its hard offset shadow, inverted for the dark
 * shell. Reserved for "here's the number" moments — never for ordinary content,
 * or it stops meaning anything.
 */
function OffsetCard({ children, className = "" }) {
  return (
    <div className={`offset-card bg-card p-7 md:p-9 ${className}`}>
      {children}
    </div>
  );
}

export default OffsetCard;
